import React from 'react';
import { AccountSettingsLayout } from '../../components/ScreenContainer/AccountSettingsLayout';
import { account_settings_data } from '../../data/saccount_settings.data';
import { Box, useMediaQuery, useTheme } from '@mui/material';

const AccountSettings = () => {
    const muiTheme = useTheme();
    const betweenMdAndLg = useMediaQuery(muiTheme.breakpoints.between(990, 1300));
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                maxWidth: { xs: '100%', sm: '100%', xl: '110%' },
                ml: { xs: 0, sm: 10 },
                ...(betweenMdAndLg && { maxWidth: '90%', ml: 30 }),
                // Change this behavior in smaller screens
            }}>
            <AccountSettingsLayout menuItems={account_settings_data} />
        </Box>
    );
};

export { AccountSettings };
